import React, { useRef } from 'react'

import classNames from 'classnames'
import { useClickOutside } from 'shared/hooks'

import classes from './Dropdown.module.scss'

interface Props {
  right?: boolean
  isMenuVisible?: boolean
  outSideClick: () => void
}

export const Dropdown = (
  props: React.HTMLAttributes<HTMLElement> & Props
): JSX.Element => {
  const ref = useRef(null)
  useClickOutside(ref, () =>
    props?.isMenuVisible ? props.outSideClick() : false
  )

  const cn = classNames([
    props.className,
    classes.dropdown,
    {
      [classes['dropdown--open']]: props?.isMenuVisible,
      [classes['dropdown--right']]: props.right,
    },
  ])

  return (
    <div
      ref={ref}
      onMouseUp={e => (props.onClick ? props.onClick(e) : null)}
      className={cn}
    >
      {props.children}
    </div>
  )
}
